var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-link fw-light",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.modal = true
            },
          },
        },
        [
          _vm._v("\n        Utaztál már velünk? Írd meg a véleményed te is "),
          _c("i", { staticClass: "fa-solid fa-arrow-right" }),
        ]
      ),
      _vm._v(" "),
      _vm.modal
        ? _c("CreateModal", {
            attrs: { url: _vm.url },
            on: {
              closed: function ($event) {
                _vm.modal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }